<template>
  <div class="app">
    <router-view v-if="ready" />
    <portal-target name="app" />
  </div>
</template>

<script>
import { mapGetters} from 'vuex'
import {api} from '@/api/api'
import redirectMixin from '@/mixins/redirect-mixin'


export default {
  name: 'App',
  mixins:[redirectMixin],
  data(){
    return {
      ready: false
    }
  },

  computed: {
    ...mapGetters(['check_status','userInfo'])
  },

  async beforeMount() {
    if (['login', 'register'].includes(this.$route.name)) {
      localStorage.removeItem('access_token')
    }else {
      await this.$store.dispatch('setSettings')
    }
    if (['uk', 'en'].includes(this.$route.params.lang)) {
     this.$root.$i18n.locale = this.$route.params.lang
    } else {
      this.$root.$i18n.locale = 'uk'
      await this.$router.replace({params: {lang: 'uk'}})
    }


    const checkAvailability = await this.updateLanguage()

    try {
      if (checkAvailability) {
        if (!['login'].includes(this.$route.name)) {
          await this.$store.dispatch('setUserInfo')
        }

        this.ready = true
        if (!['login', 'password-change', 'password-change', 'register', 'diya-qr-code', 'diya-qr-success', 'diya-qr-sign-success' ].includes(this.$route.name)) {
          const accessToken = localStorage.getItem('access_token')
          if (!accessToken) {
            await this.$router.push({name: 'login'})
          }
          await this.redirect()

        }
      } else {
        if (['server-error-placeholder'].includes(this.$route.name)) {
          this.ready = true
        }
      }
    } catch (err) {

        this.$toast.error(this.$t('notifications.something-went-wrong'))
        console.log(err)

    }

  },
  methods: {
    async updateLanguage() {
      const formData = new FormData()
      formData.append('interface_language', this.$root.$i18n.locale)
      try {
        await api.auth.updateUserInfo(formData)
        return true
      }catch(err) {
        return false

      }
    }

  }
}
</script>
